import React, {ReactNode} from 'react';

export type DropDownItemProps = {
    children: ReactNode,
    onMouseUp?: (e: any) => void
}

function DropDownItem(props: DropDownItemProps) {
    return (
        <div className={"dropdown-item"} onMouseUp={props.onMouseUp}>
            {props.children}
        </div>
    );
}

export default DropDownItem;
